import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import GiftCardDetailModal from './GiftCardDetailModal';

const GiftcardCard = ({
	item,
	getSearchedCountry,
	handleSelect,
	isSelected,
	value,
	fromSearch,
	country,
}) => {
	const [state, setState] = useState({
		showModal: false,
		code: '',
		currencySymbol: '',
	});
	const { showModal, code, currencySymbol } = state;

	const handleViewModal = (item, country) => {
		let temp = '';
		let tempCountryObj = {};
		if (country) {
			tempCountryObj = getSearchedCountry.find(
				(_item) => _item.value.toLowerCase() === country.toLowerCase(),
			);
		}
		setState((prevState) => ({
			...prevState,
			showModal: true,
			code: item,
			currencySymbol: tempCountryObj?.symbol,
		}));
	};

	const isSelectedCard = (array, object, fromSearch) => {
		let exists;
		if (fromSearch) {
			exists = array?.some(
				(value) => value.id === object.id && value.status,
			);
		} else {
			exists = array?.some(
				(value) =>
					value.id === object.id &&
					value.code === object.code &&
					value.status,
			);
		}
		if (exists) {
			return true;
		} else {
			return false;
		}
	};

	return (
		<div className=''>
			<div
				className={
					isSelected &&
					isSelectedCard(
						isSelected,
						{ code: value, id: item.id },
						fromSearch,
					)
						? 'giftcard_voucher_box selected_voucher'
						: 'giftcard_voucher_box'
				}>
				<div className='gc_imagebox'>
					<img
						src={item?.image}
						alt=''
					/>
					<div className='gc_overlay'>
						<div className='gc_overlay_box'>
							<ul>
								<li>
									<Link
										to=''
										onClick={() =>
											handleViewModal(item, country)
										}>
										View Details
									</Link>
								</li>

								<li>
									<Link
										to=''
										onClick={() =>
											handleSelect(
												item.id,
												fromSearch,
												item,
											)
										}>
										{isSelected &&
										isSelectedCard(
											isSelected,
											{
												code: value,
												id: item.id,
											},
											fromSearch,
										)
											? 'Unselect'
											: 'Select'}
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className='row giftcard_voucher_details'>
					<div className='giftcard_voucher_title'>
						<h5>{item?.title}</h5>
					</div>
				</div>
			</div>
			{showModal && (
				<GiftCardDetailModal
					show={showModal}
					close={() =>
						setState((prev) => ({ ...prev, showModal: false }))
					}
					code={code}
					currencySymbol={currencySymbol}
				/>
			)}
		</div>
	);
};

export default GiftcardCard;
